module.exports = __webpack_public_path__ + "static/8-54ed2fab9c30bb59ed284ab0b971f42e.jpg";